import { createUnknownErrorResult } from '@/entities/FetchResult'
import { reportError } from '@/helpers/errorReporting'

import { FetchResult, FetchResultType } from './FetchResult'

export const getLatestVersion = async (): Promise<FetchResult<string, string>> => {
    try {
        const latestVersionResponse = await fetch(`${process.env.PUBLIC_URL}/version-latest.json`, {
            headers: { 'Cache-Control': 'no-cache' },
        })

        const latestVersionJson = await latestVersionResponse.json()
        const latestVersion = latestVersionJson.version

        return {
            status: 200,
            type: FetchResultType.Success,
            data: latestVersion,
        }
    } catch (error) {
        reportError('getLatestVersion', error)

        return createUnknownErrorResult(500)
    }
}
